// A sticky column that never needs its own scrollbar. When it fits in the window it sticks at `top`.
// When it's taller, it scrolls with the page until one edge is in view, then sticks there: its bottom
// while scrolling down, its top while scrolling up. It works by moving the sticky `top` offset with
// the scroll, kept between `top` and the offset that puts its bottom `gap` above the window's bottom.
import { rafBatch } from './dom';

export function followScroll(el: HTMLElement, opts: { top: number; gap: number; media: string }): void {
  const active = matchMedia(opts.media);
  let offset = opts.top;
  let lastY = scrollY;
  const update = () => {
    const dy = scrollY - lastY;
    lastY = scrollY;
    if (!active.matches) return;
    const lowest = Math.min(opts.top, innerHeight - el.offsetHeight - opts.gap);
    offset = Math.max(lowest, Math.min(opts.top, offset - dy));
    el.style.top = `${offset}px`;
  };
  const schedule = rafBatch(update);
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule);
  new ResizeObserver(schedule).observe(el);
}
